export default __webpack_public_path__ + "static/media/logo sport (1).630fa5ec.png";